/**
 * PRZEWIJANIE RZĘDU MYSZĄ (układ filtrów Maćka 6.10, pulpit). Mysz nie ma gestu w bok, więc rząd
 * chipów przewija się na trzy sposoby: gładzik (jak dotąd), zwykłe kółko nad rzędem (w bok zamiast
 * strony) i przeciągnięcie z wciśniętym przyciskiem. Tu same decyzje — bez DOM — żeby dało się je
 * przetestować; podpięcie zdarzeń w `ScrollableRow` (`mysz`).
 */

/** Ruch krótszy niż tyle pikseli to wciąż kliknięcie (chipa albo jego ×), nie przeciągnięcie. */
export const PROG_PRZECIAGNIECIA_PX = 5;

/**
 * Nowe `scrollLeft` po obrocie kółka albo `null`, gdy kółko ma przewinąć stronę: ruch głównie
 * poziomy (gładzik robi to sam), rząd się nie przewija albo jest już na końcu w tym kierunku —
 * wtedy strona nie może utknąć na rzędzie.
 */
export function przesuniecieKolkiem(
  deltaX: number,
  deltaY: number,
  scrollLeft: number,
  maksScroll: number,
): number | null {
  if (Math.abs(deltaX) >= Math.abs(deltaY)) return null;
  if (maksScroll <= 0) return null;
  const nowe = Math.min(maksScroll, Math.max(0, scrollLeft + deltaY));
  return nowe === scrollLeft ? null : nowe;
}

/** Czy ruch od naciśnięcia jest już przeciągnięciem (a nie kliknięciem). */
export function toPrzeciagniecie(dx: number): boolean {
  return Math.abs(dx) >= PROG_PRZECIAGNIECIA_PX;
}
